import React, { useState, useEffect } from 'react';
import { SvgIcons } from 'common/consts/svgIcons';
import SvgIcon from 'components/Icon/Icon';
import TagManager from 'react-gtm-module';
import {
  Adjust_payment_plan,
  Plan_update_type,
} from 'common/consts/GtmVariableValues';
interface Props {
  PageData?: any;
  Model?: any;
  onClose: () => void;
}

const PayerReviewThankYouPanel = ({ Model, PageData, onClose }: Props) => {
  const [eventTracked, setEventTracked] = useState<boolean>(false);
  useEffect(() => {
    if (eventTracked == false) {
      var tagManagerArgs: any;
      var agreedAmount = parseFloat(
        Model?.PlanDetails?.PlanDetailsFinalPaymentAmountRaw
          ? Model?.PlanDetails?.PlanDetailsFinalPaymentAmountRaw
          : '0',
      );
      var finalAmount = parseFloat(
        Model?.PlanDetails?.PlanDetailsFinalInstallmentAmountRaw
          ? Model?.PlanDetails?.PlanDetailsFinalInstallmentAmountRaw
          : '0',
      );
      var adjustType =
        Model?.PlanDetails?.PaymentPlanType ==
          'Update payment plan payment method'
          ? Adjust_payment_plan.PaymentMethod
          : Model?.PlanDetails?.PaymentPlanType == 'Update payment plan amount'
            ? Adjust_payment_plan.RateAmount
            : Model?.PlanDetails?.PaymentPlanType == 'Update payment plan date'
              ? Adjust_payment_plan.PaymentDate
              : '';

      var updateType =
        Model?.PlanDetails?.PaymentPlanType ==
          'Update payment plan payment method'
          ? Plan_update_type.PaymentMethodUpdate
          : Model?.PlanDetails?.PaymentPlanType == 'Update payment plan amount'
            ? Plan_update_type.AmountUpdate
            : Model?.PlanDetails?.PaymentPlanType == 'Update payment plan date'
              ? Plan_update_type.DateUpdate
              : '';
      var installmentRemaining = (Model?.PlanDetails?.PlanDetailsFinalPaymentAmountRaw == Model?.PlanDetails?.PlanDetailsFinalInstallmentAmountRaw) ? Model?.PlanDetails?.PlanDetailsNumberofInstallmentsRaw : Model?.PlanDetails?.PlanDetailsNumberofInstallmentsRaw - 1;

      tagManagerArgs = {
        dataLayer: {
          event: 'adjust_payment_plan',
          adjust_type: adjustType,
          payment_method: Model?.PlanDetails?.PlanDetailsPaymentMethodRaw,
          payment_frequency: 'Monthly',
          installment_count: installmentRemaining,
          final_installment_amount: ((finalAmount > 0) ? (finalAmount / 100) : 0).toFixed(2),
          agreed_rate_amount: ((agreedAmount > 0) ? (agreedAmount / 100) : 0).toFixed(2),
          self_payer: Model?.IsManualPaymentMethod,
          update_type: updateType,
          checkout_name: 'Payment Plan Review',
        },
      };
      TagManager.dataLayer(tagManagerArgs);
      setEventTracked(true);
    }
  }, [eventTracked]);
  return (
    <div data-type="Promotion" data-creative-slot="Portal-Home-Top" data-promotion-name="Payer review" >
      <div
        className="CreateRepaymentPlan__section u-posRelative"
        id="ThankyouPanel"
      >
        <div className="review_wrapper">
          <div className="Grid-cell u-lg-size1of1 u-textCenter">
            <button
              onClick={() => onClose()}
              className="reviewplanclose"
            ></button>
            <div className="u-marginTsm u-marginB">
              <img
                src={
                  process.env.PUBLIC_URL +
                  '/images/icons/' +
                  SvgIcons.CONFIRMATION +
                  '.svg'
                }
              />
            </div>
            <h2 className="Heading h2 Heading-h2--portal">
              {PageData?.ThankYouForReviewingYourPlanLabel}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayerReviewThankYouPanel;
